import * as React from "react";
const SvgFiRrArrowToBottom = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18 22h-4.517q.15-.105.285-.232l4.95-4.95A1.003 1.003 0 0 0 17.3 15.4L13 19.7V1.031a1 1 0 0 0-2 0v18.676L6.7 15.4a1 1 0 0 0-1.414 1.414l4.95 4.95q.134.127.285.232H6a1 1 0 1 0 0 2h12a1 1 0 0 0 0-2z"
    />
  </svg>
);
export default SvgFiRrArrowToBottom;
